import React from "react";
import { useTranslation } from "react-i18next";
import classNames from "classnames";
import styles from "./product-mpn.module.scss";

export interface ProductMpnProps {
  code?: string;
  className?: string;
}

export const ProductMpn: React.FC<ProductMpnProps> = ({ code = "", className }) => {
  const { t } = useTranslation();
  return (
    <div className={classNames(styles.root, className)}>
      <div className={styles.label}>{t("zdfw6dq1f34n1u02.item-number", { defaultValue: "MPN" })}:</div>
      <div className={styles.code}>{code}</div>
    </div>
  );
};

export default ProductMpn;
